// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: 'b824e3a',
    builtAt: '2026-09-17T15:22:13.613Z',
} as const;
